<template>
  <table class="table table-details">
    <tr>
      <td><label>{{ $t('generic.id') }}</label></td>
      <td>{{ details.id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('purchaseDetails.operation_ts') }}</label></td>
      <td>{{ details.operation_ts | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('purchaseDetails.account_id') }}</label></td>
      <td>{{ details.account_id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.created') }}</label></td>
      <td>{{ details.created_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.updated') }}</label></td>
      <td>{{ details.updated_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('purchaseDetails.charge') }}</label></td>
      <td>{{ details.charge | price }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('purchaseDetails.discount_id') }}</label></td>
      <td>{{ details.discount_id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('purchaseDetails.product_type') }}</label></td>
      <td>{{ details.product_type }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('purchaseDetails.fare_id') }}</label></td>
      <td>{{ details.fare_id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('purchaseDetails.fare_group_id') }}</label></td>
      <td>{{ details.fare_group_id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('purchaseDetails.operator_id') }}</label></td>
      <td>{{ details.operator_id }}</td>
    </tr>
  </table>
</template>
<script>

export default {
  name: 'purchaseDetails',
  components: {},
  props: {
    details: {
      type: Object,
      required: true,
    }
  },
  computed: {}
};
</script>
<style></style>
